{
    "AutocalcdurationLabel": "Dauer beim Planen des Berichts automatisch berechnen:",
    "BundleallemailattachinzipLabel": "Bündeln Sie alle E-Mail-Anhänge in einer Zip-Datei:",
    "RunandcollatewithsimilarschedLabel": "Ausführen und Sortieren mit ähnlichen Zeitplänen für regelmäßige Berichte:",
    "Advanced_SectionHeader": "Fortschrittlich",
    "NAME": "Advanced"
}